module.exports = __webpack_public_path__ + "img/elo.fe031a6.svg";